import {
  IMPORTAR_CATALOGO_PROPIO_REQUEST,
} from '../constants/catalogosPropios.constants';

export const importarCatalogoPropio = ({ proveedor, fileList }) => ({
  type: IMPORTAR_CATALOGO_PROPIO_REQUEST,
  payload: {
    proveedor,
    fileList,
  },
});
